"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientProvider = void 0;
var async_mqtt_1 = __importDefault(require("async-mqtt"));
/**
 * Factory for creating an AsyncMqttClient.
 */
var ClientProvider = /** @class */ (function () {
    /**
     * @param brokerUrl Eg. wss://xxxxxxxxxxxxxx-ats.iot.us-east-1.amazonaws.com:443/mqtt
     * @param accessTokenManager a manager instance for providing a JWT access token
     * @param application an indentifier for the application publishing messages
     * @param authorizer whether to authorize as a publisher or subscriber
     * @param doConnect a function that creates an AsyncClient
     * @param opts additional options passed to the the connect function
     */
    function ClientProvider(brokerUrl, accessTokenManager, application, authorizer, logger, opts, doConnect) {
        if (logger === void 0) { logger = console; }
        if (doConnect === void 0) { doConnect = async_mqtt_1.default.connectAsync; }
        this.brokerUrl = brokerUrl;
        this.accessTokenManager = accessTokenManager;
        this.application = application;
        this.authorizer = authorizer;
        this.logger = logger;
        this.opts = opts;
        this.doConnect = doConnect;
    }
    ClientProvider.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var allowReconnect_1, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.instance != null && this.instance.connected) {
                            return [2 /*return*/, this.instance];
                        }
                        if (this.instanceConnect == null) {
                            allowReconnect_1 = this.authorizer === "subscriber";
                            this.instanceConnect = this.accessTokenManager.init().then(function () { return _this.doConnect(_this.brokerUrl, __assign(__assign({ connectTimeout: 10 * 1000 }, _this.opts), { username: "?x-amz-customauthorizer-name=".concat(_this.authorizer, "&application=").concat(_this.application, "&accessToken=").concat(_this.accessTokenManager.getAccessToken()), transformWsUrl: function (url, _options, client) {
                                    client.options.username = "?x-amz-customauthorizer-name=".concat(_this.authorizer, "&application=").concat(_this.application, "&accessToken=").concat(_this.accessTokenManager.getAccessToken());
                                    return url;
                                } }), allowReconnect_1); }).then(function (client) {
                                client.on("error", function (error) {
                                    _this.logger.error("".concat(error));
                                });
                                if (!allowReconnect_1) {
                                    client.on("close", function () {
                                        delete _this.instance;
                                        delete _this.instanceConnect;
                                    });
                                }
                                return client;
                            });
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 3, 4]);
                        _a = this;
                        return [4 /*yield*/, this.instanceConnect];
                    case 2: return [2 /*return*/, _a.instance = _b.sent()];
                    case 3:
                        delete this.instanceConnect;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ClientProvider;
}());
exports.ClientProvider = ClientProvider;
//# sourceMappingURL=ClientProvider.js.map